import styled from '@emotion/styled';
import type { ReactElement } from 'react';

import { Theme } from '../../../theme/interface/detailed';
import { useTheme } from '../../../theme/useTheme';
import { Interface } from './interface';

export const SwitchCameraIcon = styled((props: Interface): ReactElement => {
	const theme = useTheme();
	return (
		<div {...props}>
			<svg
				width={theme.videoCalls.icons.switchCameraIcon.width}
				height={theme.videoCalls.icons.switchCameraIcon.height}
				viewBox="0 0 24 24"
				fill={theme.videoCalls.icons.switchCameraIcon.backgroundColor}
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M22.125 14.39V8.298a1.877 1.877 0 00-1.875-1.875h-1.423a2.812 2.812 0 01-2.663-1.906l-.283-.834a.937.937 0 00-.888-.635h-5.99a.94.94 0 00-.88.619l-.325.899a2.82 2.82 0 01-2.646 1.857H3.75a1.877 1.877 0 00-1.875 1.875v10.781c0 1.034.841 1.875 1.875 1.875h16.5a1.877 1.877 0 001.875-1.875.937.937 0 111.875 0 3.754 3.754 0 01-3.75 3.75H3.75A3.754 3.754 0 010 19.078V8.297a3.754 3.754 0 013.75-3.75h1.402a.94.94 0 00.882-.62l.325-.898a2.82 2.82 0 012.645-1.857h5.99c1.204 0 2.274.766 2.662 1.906l.283.834c.13.38.486.635.888.635h1.423A3.754 3.754 0 0124 8.297v6.094a.937.937 0 11-1.875 0zm-11.382.141a.937.937 0 00-.938-.937h-2.39a1.881 1.881 0 00-1.884 1.875v2.344a.937.937 0 101.875 0v-.921a5.91 5.91 0 004.735 2.374 5.913 5.913 0 005.906-5.907 5.913 5.913 0 00-5.906-5.906 5.928 5.928 0 00-5.116 2.952.938.938 0 001.623.94 4.047 4.047 0 013.493-2.017 4.036 4.036 0 014.03 4.031 4.036 4.036 0 01-4.03 4.032 4.035 4.035 0 01-3.438-1.922h1.102c.518 0 .938-.42.938-.938z"
					fill={theme.videoCalls.icons.switchCameraIcon.fill}
				/>
			</svg>
		</div>
	);
})(({ theme }: { theme?: Theme }) => theme?.videoCalls.icons.switchCameraIcon);
